// src/pages/EducationSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const EducationSupport: React.FC = () => <CategoryPage categoryId="education" art="documents" />;

export default EducationSupport;
